import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AdminFacade } from '@app/store/admin';
import { UnavailableComponent } from '@shared/components';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-admin-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, DatePipe, ButtonModule, DeleteButtonComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly adminFacade = inject(AdminFacade);

    readonly admin = this.adminFacade.admin;
    readonly loading = this.adminFacade.loading;
    readonly error = this.adminFacade.error;
    readonly saving = this.adminFacade.saving;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.adminFacade.getAdmin(id);
        }

        effect(() => {
            if (this.adminFacade.saved()) {
                this.close({ replaceUrl: !this.adminFacade.admin() });
            }
        });
    }

    ngOnDestroy(): void {
        this.adminFacade.clear();
    }

    onEdit(): void {
        const admin = this.admin();
        if (admin) {
            this.router.navigate([{ outlets: { modal: ['admins', 'edit', admin.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
